import { render, staticRenderFns } from "./EditorMailingAddress.vue?vue&type=template&id=9a3c0062&scoped=true&"
import script from "./EditorMailingAddress.vue?vue&type=script&lang=js&"
export * from "./EditorMailingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3c0062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a3c0062')) {
      api.createRecord('9a3c0062', component.options)
    } else {
      api.reload('9a3c0062', component.options)
    }
    module.hot.accept("./EditorMailingAddress.vue?vue&type=template&id=9a3c0062&scoped=true&", function () {
      api.rerender('9a3c0062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorMailingAddress.vue"
export default component.exports